"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateFreeTrialEndDate = exports.calculateSubscriptionDates = void 0;
var luxon_1 = require("luxon");
var calculateSubscriptionDates = function (_a) {
    var recurringSettings = _a.recurringSettings;
    var startDate = recurringSettings.startDate.kind === "value" ? new Date(recurringSettings.startDate.value) : null;
    var anchorDate = recurringSettings.anchorDate.kind === "value" ? new Date(recurringSettings.anchorDate.value) : null;
    var endDate = recurringSettings.endDate.kind === "value" ? new Date(recurringSettings.endDate.value) : null;
    var cycles = (recurringSettings.endDate.kind === "cycles" && recurringSettings.endDate.value) || null;
    return {
        startDate: startDate,
        anchorDate: (anchorDate === null || anchorDate === void 0 ? void 0 : anchorDate.getTime()) === (startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) ? null : anchorDate,
        endDate: endDate,
        cycles: cycles,
    };
};
exports.calculateSubscriptionDates = calculateSubscriptionDates;
var calculateFreeTrialEndDate = function (_a) {
    var freeTrialDays = _a.freeTrialDays, startDate = _a.startDate, timezone = _a.timezone;
    return luxon_1.DateTime.fromJSDate(startDate, { zone: timezone }).plus({ days: freeTrialDays }).toJSDate();
};
exports.calculateFreeTrialEndDate = calculateFreeTrialEndDate;
